import React from 'react';
import {
  Typography,
  Box,
  Container,
  Grid,
} from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import resort from '../../images/resort.png';
import image1 from '../../images/swiper1.jpg';
import image2 from '../../images/swiper2.jpg';
import image3 from '../../images/swiper3.jpg';
import image4 from '../../images/swiper4.jpg';
import image5 from '../../images/swiper5.jpg';
import image6 from '../../images/swiper6.jpg';
import image7 from '../../images/swiper7.jpg';
import image8 from '../../images/swiper8.jpg';
import image9 from '../../images/swiper9.jpg';
import image10 from '../../images/swiper10.jpg';

import './sectow.css';

function Sectwo() {
  return (
    <Box sx={{ backgroundColor: '#fff', py: 10, px: { xs: 3, md: 10 }, textAlign: 'center' }}>
      {/* Header Section */}
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <img src={resort} alt="Resort Icon" style={{ height: '50px', width: '50px' }} />
        </Box>

        <Typography
          variant="body2"
          sx={{
            textTransform: 'uppercase',
            fontWeight: 700,
            letterSpacing: '0.1em',
            color: '#2e8b57',
            mb: 2,
          }}
        >
          Unseen Knuckles Eco Boutique
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.8rem' },
            fontFamily: "'Playfair Display', serif",
            mb: 3,
            color: '#000',
          }}
        >
          Luxury Eco Retreat in the Heart of <br /> Sri Lanka’s Knuckles Mountain Range
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: '#444', fontSize: '1.1rem', lineHeight: 1.8, mb: 6 }}
        >
          Welcome to Unseen Knuckles Eco Boutique, a sustainable eco resort located in the breathtaking
          Knuckles Mountain Range of Sri Lanka. Designed for nature lovers, adventure seekers, and
          conscious travelers, our boutique retreat offers a unique opportunity to experience luxury in
          harmony with nature.
        </Typography>
      </Container>

      {/* Two Column Section */}
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: '#ffffff',
                p: 5,
                borderRadius: '16px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: '#2e8b57',
                  fontWeight: 600,
                  mb: 3,
                  fontFamily: "'Playfair Display', serif",
                  fontSize: '1.8rem',
                }}
              >
                Eco-Friendly Accommodation
              </Typography>
              <Typography sx={{ mb: 3, fontSize: '1.05rem', color: '#333' }}>
                Nestled amidst lush greenery, misty mountains, and scenic trails,
                Unseen Knuckles offers eco-friendly accommodation in Sri Lanka’s
                UNESCO-listed Knuckles Conservation Forest. Our well-appointed
                rooms and private villas feature:
              </Typography>
              <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem', color: '#2e8b57', marginBottom: '1.5rem', textAlign: 'left' }}>
                <li>Sustainable design and natural materials</li>
                <li>Panoramic mountain and forest views</li>
                <li>Plush bedding and modern eco-conscious amenities</li>
                <li>Private balconies perfect for sunrise and stargazing</li>
              </ul>
              <Typography sx={{ fontSize: '1rem', color: '#333' }}>
                Whether you’re seeking a peaceful nature retreat in Sri Lanka or a romantic
                escape off the beaten path, we invite you to stay in comfort without
                compromising the environment.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: '#ffffff',
                p: 5,
                borderRadius: '16px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: '#2e8b57',
                  fontWeight: 600,
                  mb: 3,
                  fontFamily: "'Playfair Display', serif",
                  fontSize: '1.8rem',
                }}
              >
                Authentic Sri Lankan Experiences
              </Typography>
              <Typography sx={{ mb: 3, fontSize: '1.05rem', color: '#333' }}>
                At Unseen Knuckles, every moment is an invitation to explore and reconnect.
                We offer curated experiences that blend adventure, relaxation, and culture:
              </Typography>
              <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem', color: '#2e8b57', marginBottom: '1.5rem', textAlign: 'left' }}>
                <li>Guided hikes to hidden waterfalls and panoramic viewpoints</li>
                <li>Birdwatching, forest bathing, and off-the-grid exploration</li>
                <li>Cultural visits to local villages and heritage sites</li>
                <li>Poolside relaxation and farm-to-table dining using local, organic ingredients</li>
              </ul>
              <Typography sx={{ fontSize: '1rem', color: '#333' }}>
                Looking for eco adventure tourism in Sri Lanka? Our expert local guides and personalized
                itineraries ensure an unforgettable journey into the wild.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
      {/* Sustainable Travel Section */}
      <Container maxWidth="md" sx={{ mt: 10, textAlign: 'center' }}>
        
        <Typography
          variant="h4"
          sx={{
            fontFamily: "'Playfair Display', serif",
            color: '#2e8b57',
            fontWeight: 600,
            mb: 3,
            fontSize: { xs: '1.8rem', md: '2rem' },
          }}
        >
          
          Sustainable Travel with Heartfelt Hospitality
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: '1.1rem',
            color: '#333',
            lineHeight: 1.8,
            maxWidth: '800px',
            margin: '0 auto',
          }}
        >
          As a boutique eco hotel committed to sustainable travel in Sri Lanka, we focus on low-impact tourism,
          community support, and environmental conservation. From renewable energy to responsible sourcing and
          waste reduction, your stay actively contributes to protecting the Knuckles region. Our passionate team
          is here to make your experience meaningful—from the warm welcome to the final farewell.
        </Typography>
      </Container>

      {/* Swiper Section */}
      <Container maxWidth="lg" sx={{ mt: 10 }}>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {[image1, image2, image3, image4, image5, image6, image7, image8, image9, image10].map(
            (img, idx) => (
              <SwiperSlide key={idx}>
                <img src={img} alt={`Slide ${idx + 1}`} className="swiper-image" />
              </SwiperSlide>
            )
          )}
        </Swiper>
      </Container>

      {/* Final Caption */}
      <Typography
        variant="body2"
        sx={{
          fontSize: '1rem',
          fontStyle: 'italic',
          color: '#6c757d',
          mt: 4,
          textAlign: 'center',
          fontFamily: 'Dancing Script, cursive',
        }}
      >
        Inspired by our history, surrounded by nature and designed to offer a different experience
      </Typography>
    </Box>
  );
}

export default Sectwo;
